import $ from 'jquery';
import Cookies from 'js-cookie';
import siteApi from './api/siteApi';
import clubApi from './api/clubApi';

import modalModule from './modules/modal';
import snackbar from './snackbar';

require('jquery-validation');
require('jquery-validation/dist/additional-methods');

/**
 * Form - Class representing Form builder and validation
 * Only forms that have class .form-baby-web will be validated
 */
export default class Form {
  constructor() {
    // Adding custom compareField function to check and compare value of two input fields
    $.validator.addMethod('compareField', (value, element, param) => {
      const inputToValidate = $(element).closest('form').find($(param));
      return $(element).val() === inputToValidate.val();
    });

    this.forms = $('form.form-baby-web');
    this.vueForms = $('form.form-baby-vue');
    this.formRules = {};
    this.currentForm = {};
    this.formData = {};
    this.specificField = null;

    // Custom forms
    this.deleteUserForm = $('#delete-user-form');
  }

  /**
   * This class finds all forms on page that have .form-baby-web class, loop through all
   * inputs found inside of form, creates validation depending on data attributes on fields.
   * After submittion all values inside of form are stored in object and then sent using ajax.
   *
   * Options are taken from the data attributes of input fields found inside of form and those are:
   * data-required="1" - 1/0 true/false : Is this field required
   * data-dependent-name="input_name" - Name of an input
   *  that should be selected to validate this field
   * data-dependent-value="phone" - Value that input should have
   * data-message-required="Message" - Message that will be shown if input value is empty
   * data-pattern="^\\w+@[a-zA-Z_]+?\\.[a-zA-Z]{2,3}$" - regex pattern for specific field
   * data-message-pattern="Pattern not correct" - Message when field value doesn't meet pattern
   * data-compare-value-to-field="input_name" - Name of an input that will be compared
   * data-compare-value-to-field-validation-error="Required" - Message that will be shown
   *  if validation fails
   * data-max-length="14" - Max length of given input value
   * data-message-max-length="Max length exceeded" - Message when field value exceed maximum length
   * data-min-length="3" - Min length of given input value
   * data-message-min-length="Min length is 3" - Message when field value is less then given length
   *
   * NOTE: Url will be taken from form action attribute. Example:<form action="/register">...</form>
   * Fields that are dependent will only be shown once dependent input is selected (radio/checkbox)
   *
   * Reference for usage: src\generic-form.html
   */

  init() {
    this.forms = $('form.form-baby-web');
    this.vueForms = $('form.form-baby-vue');
    this.forms.each((index) => {
      const form = $(this.forms[index]);
      const errorField = form.find('.form-error');
      this.currentForm = form;
      this.cloneIndex = 1;
      this.createFormRules(errorField);
      this.registerFieldMultiple(form);
      this.registerDynamicInputs();
      this.registerRemoveInputs();

      // Custom forms
      this.registerDeleteUserForm();
    });

    this.vueForms.each((index) => {
      const form = $(this.vueForms[index]);
      const errorField = form.find('.form-error');
      this.currentForm = form;
      this.cloneIndex = 1;
      this.createFormRules(errorField, true);
      this.registerFieldMultiple(form, true);
      this.registerDynamicInputs();
      this.registerRemoveInputs();

      // Custom forms
      this.registerDeleteUserForm();
    });
  }

  /**
   * Validate specific field
   * @param {*} field Input refrenece of specific field
   */
  validateField(field) {
    this.specificField = field;
    $(this.specificField).valid();
  }

  /**
   * Create form rules for validation
   * @param {Object} errorField Error field object
   * @param {Bool} vue If validation is for Vue forms
   */
  createFormRules(errorField, vue = false) {
    this.formRules = {
      errorElement: 'span',
      errorPlacement(error, element) {
        if (element.closest('.select').length) {
          element.closest('.select').addClass('error');
        } else if (element.closest('.radio-row__container').length) {
          element.closest('.radio-row__container').append(error);
        } else if (element[0].type === 'checkbox') {
          const lastItem = element.closest('.form-field').children('.input-wrapper').last();
          lastItem.addClass('error');
          lastItem.append(error);
        } else {
          element.closest('.input-wrapper').append(error);
          // error.insertAfter(element);
        }
      },
      groups: {
        names: '',
      },
      rules: {},
      messages: {},
      onkeyup: false,
      onclick(element) {
        if (element.type === 'checkbox') {
          $(element).closest('.form-field').find('input').valid();
        }
      },
      onfocusout(element) {
        // Remove validation of datepicker since validation is handled from calendar.js
        if (!element.classList.contains('js-datepicker')) {
          $(element).valid();
        }
      },
      // Highlight the parent element on error
      highlight(element) {
        const inputs = $(element).closest('.form-field').find('.input-wrapper');
        $(element).closest('.input-wrapper').addClass('error');

        if (inputs.length > 1) {
          inputs.removeClass('error');
          inputs.last().addClass('error');
        }
      },
      // Remove the class from the parent element on success
      unhighlight(element) {
        $(element).closest('.input-wrapper').removeClass('error');
      },
      async submitHandler(formElement, event) {
        event.preventDefault();
        const modal = modalModule();

        if (modal) {
          modal.then((eventModule) => {
            eventModule.init();
          });
        }
        if (!vue) {
          const submitButton = $('button[type="submit"]');
          const modalElement = $('[data-form-modal-id]');
          const modalId = modalElement.attr('data-form-modal-id');
          const formModalElement = $(`#${modalId}`);
          if (formModalElement.length) {
            if (!formModalElement.hasClass('opened')) {
              formModalElement.addClass('opened');
              return;
            }
          }

          $(submitButton).toggleClass('progress');
          if (errorField) {
            errorField.text('');
          }
          const formInstance = $(formElement);
          const formUrl = formInstance.attr('action');
          const formArray = formInstance.serializeArray();
          this.formData = {};
          /**
           * Generating JSON from form fields. If field includes []
           * that is used for making array of values for input,
           * parse it as array of data. eg: <input name="inputName[]"> it will parse as send output:
           * "inputName: ['value1', 'value2']"
           * Without this logic it would be parsed like: inputName[]:
           * 'value2' (only one value and bracets inside of propery name)
           */
          for (let i = 0; i < formArray.length; i += 1) {
            if (formArray[i].name.includes('[]')) {
              const fieldArrayName = formArray[i].name.replace('[]', '');
              if (this.formData[fieldArrayName]) {
                this.formData[fieldArrayName].push(formArray[i].value);
              } else {
                this.formData[fieldArrayName] = [];
                this.formData[fieldArrayName].push(formArray[i].value);
              }
            } else if (formArray[i].value !== '') {
              this.formData[formArray[i].name] = formArray[i].value;
            }
          }
          if (formUrl) {
            try {
              // Add url attribute to request payload
              const queryString = window.location.search;
              const urlParams = new URLSearchParams(queryString);
              const source = urlParams.get('source');
              if (source) {
                this.formData.source = source;
              }
              const response = await siteApi.post(formUrl, this.formData);
              if (response.data.redirectUrl) {
                const dataLayer = window.dataLayer || [];
                const formLabelGa = formInstance.data('ga-label');
                // IF Login was successfull we push analytics data
                if (formLabelGa === 'LOGIN') {
                  dataLayer.push({
                    event: 'ga4_login',
                  });
                  // IF Registration was successfull we push analytics data
                } else if (formLabelGa === 'REGISTRATION') {
                  dataLayer.push({
                    event: 'ga4_sign_up',
                    ga4_data: {
                      method: 'form',
                      step_name: 'Begin registration',
                    },
                  });
                } else if (formLabelGa === 'EMAILVERIFICATION') {
                  dataLayer.push({
                    event: 'ga4_sign_up',
                    ga4_data: {
                      method: 'form',
                      step_name: 'Email verification',
                    },
                  });
                } else if (formLabelGa === 'ONBOARDING') {
                  dataLayer.push({
                    event: 'ga4_sign_up',
                    ga4_data: {
                      method: 'form',
                      step_name: 'Status information',
                    },
                  });
                } else if (formLabelGa === 'REGISTRATIONADDITIONALINFO') {
                  dataLayer.push({
                    event: 'ga4_sign_up',
                    ga4_data: {
                      method: 'form',
                      step_name: 'Complete your profile',
                    },
                  });
                  // IF purchase from poinshop was successfull we push analytcis data
                } else if (response.data.gtmActionField && response.data.gtmProducts) {
                  dataLayer.push({
                    event: 'eec.purchase',
                    ecommerce: {
                      currencyCode: 'EUR',
                      purchase: {
                        actionField: {
                          ...response.data.gtmActionField,
                        },
                        products: [...response.data.gtmProducts],
                      },
                    },
                  });
                }
                // If redirect is same as current url then reload page
                if (window.location.pathname === '//' || window.location.pathname === response.data.redirectUrl) {
                  window.location.reload();
                }
                window.location.href = response.data.redirectUrl;
              } else {
                $(submitButton).toggleClass('progress');

                if (response.data.formType === 'newsletter') {
                  $('.newsletter').hide();
                  $('#newsletter-thanks').show();
                }

                if (response.data.formType === 'ContactUs' && response.data.isSuccess === true) {
                  formInstance.hide();
                  const contactUsThanks = $('#contact-us-thanks');
                  contactUsThanks.find('p').text(response.data.message);
                  contactUsThanks.show();
                  $('.container--small').hide();
                }
                if (response.data.formType === 'Ovulation') {
                  const ovulationResult = $('#ovulation-result-container');
                  ovulationResult.replaceWith(response.data.result);
                }

                if (response.data.formType === 'DueDate') {
                  const birthDateResult = $('#result-container');
                  birthDateResult.replaceWith(response.data.result);
                }
              }
              if (window.grecaptcha) {
                try {
                  window.grecaptcha.reset();
                } catch {
                  // if captcha fails
                }
              }

              // Close any opened modal (forms inside modal)
              if (modal) {
                modal.then((eventModule) => {
                  eventModule.closeModal();
                });
              }
            } catch (error) {
              $(submitButton).toggleClass('progress');
              if (error.response && errorField) {
                errorField.text(error.response.data.message);
              }
              if (error.response.data.formType === 'ContactUs' && error.response.data.isSuccess === false) {
                formInstance.hide();
                $('#contact-us-down').show();
                $('.container--small').hide();
              }

              if (modal) {
                modal.then((eventModule) => {
                  eventModule.closeModal();
                });
              }

              if (window.grecaptcha) {
                try {
                  window.grecaptcha.reset();
                } catch {
                  // if captcha fails
                }
              }

              if (error.response?.data?.message) {
                snackbar.show(error.response.data.message);
              }
            }
          }
        } else {
          // Logic for event call
          event.preventDefault();
        }
      },
    };
  }

  /**
   * Register fields multiple
   * @param {Object} form Form object
   */
  registerFieldMultiple(form, vue = false) {
    const formFields = $(form).find('.form-field');
    const nestedRow = $(form).find('.radio-row__nested');
    const fieldMultiples = form.find('.field-multiple');
    // Hidding remove button if only one input field is present on the page.
    fieldMultiples.each((multipleIndex) => {
      const removeButtons = $(fieldMultiples[multipleIndex]).find('.remove-button');

      removeButtons.hide();
    });

    /**
     * Fields that are dependend on parent input are hidden on form initialization.
     * Field is dependent on some other input if it contains dependentName attribute.
     */
    formFields.each((fieldIndex) => {
      const formField = $(formFields[fieldIndex]);
      if (formField.data('dependentName')) {
        formField.hide();
      }
    });

    /**
     * Nested rows are group of fields that are dependent on parent input.
     * Initially they need to be hidden, until user update parent field (input)
     */
    nestedRow.hide();

    this.validateFields(form, formFields, vue);
    form.validate(this.formRules);
  }

  /**
   * Removing group of fields that are dynamically added
   */
  registerRemoveInputs() {
    $(this.currentForm).on('click', '.remove-button', (event) => {
      const removeButton = $(event.target);
      const fieldMultiple = removeButton.closest('.field-multiple');
      removeButton.closest('.field-group').remove();

      // Hide remove-button if only one field group is inside of form
      const removeButtons = fieldMultiple.find('.remove-button');
      if (removeButtons.length === 1) {
        removeButtons.hide();
      }
    });
  }

  /**
   * Registering copy block buttons for fields that can have multiple (array) values
   * Finds all buttons that have class .add-button
   * and attach event for copying and adding new field blocks
   */
  registerDynamicInputs() {
    const addButtons = $(this.currentForm).find('.add-button');

    addButtons.each((addButtonIndex) => {
      const addButton = $(addButtons[addButtonIndex]);
      const fieldMultiple = addButton.closest('.field-multiple');
      const fieldGroup = fieldMultiple.find('.field-group');

      addButton.on('click', () => {
        const clonedGroup = fieldGroup.clone().insertAfter('.field-group:last');
        // Reset inputs after cloning
        const clonedInputs = clonedGroup.find('input');

        clonedInputs.val('');
        clonedInputs.each((index) => {
          clonedInputs[index].name = clonedInputs[index].name.replace('[]', `[${this.cloneIndex + 1}]`);
        });
        this.cloneIndex += 1;
        const removeButtons = fieldMultiple.find('.remove-button');

        if (removeButtons.length > 1) {
          removeButtons.show();
        }

        const formFields = clonedGroup.find('.form-field');
        // Building custom rules (validation) to form fields from their data attributes.
        formFields.each((fieldIndex) => {
          const formField = $(formFields[fieldIndex]);
          const inputField = formField.find('input');
          const inputDataSet = formField.data();
          let inputRequired = false;
          if (inputField.is(':checked')) { // check preselected fields
            this.toggleDependentFields(inputField);
          }
          inputField.on('change', () => {
            this.toggleDependentFields(inputField);
          });

          if (inputDataSet.dependentName && inputDataSet.dependentValue && inputDataSet.required) {
            inputRequired = `input[name="${inputDataSet.dependentName}"][value="${inputDataSet.dependentValue}"]:checked`;
          } else if (inputDataSet.required) {
            inputRequired = parseInt(inputDataSet.required, 10) === 1;
          }
          $(inputField).rules('add', {
            required: inputRequired,
            pattern: inputDataSet.pattern ? inputDataSet.pattern : undefined,
            maxlength: inputDataSet.maxLength ? inputDataSet.maxLength : undefined,
            minlength: inputDataSet.minLength ? inputDataSet.minLength : undefined,
            messages: {
              email: inputDataSet.messagePattern ? inputDataSet.messagePattern : undefined,
              required: inputDataSet.messageRequired ? inputDataSet.messageRequired : undefined,
              pattern: inputDataSet.messagePattern ? inputDataSet.messagePattern : undefined,
              maxlength: inputDataSet.messageMaxLength ? inputDataSet.messageMaxLength : undefined,
              minlength: inputDataSet.messageMinLength ? inputDataSet.messageMinLength : undefined,
            },
          });
        });
      });
    });
  }

  /**
   * Shows or hide fields that depend on specific input selection
   * @param {Object} inputField Current input field
   */
  toggleDependentFields(inputField) {
    console.log(inputField);
    const radioRow = inputField.closest('.radio-row');
    const nestedRow = radioRow.find('.radio-row__nested');
    const inputValue = inputField.val();
    const inputName = inputField.attr('name');
    const dependentName = nestedRow.attr('data-dependent-name');
    const dependentValue = nestedRow.attr('data-dependent-value');
    const dependentFields = this.currentForm.find(`.form-field[data-dependent-name="${inputName}"]`);
    dependentFields.each((dependentIndex) => {
      const dependentField = $(dependentFields[dependentIndex]);
      const previousValue = dependentField.find('input').val();
      if (dependentField.attr('data-dependent-value') === inputValue) {
        dependentField.show();
        dependentField.find('input').show();
      } else {
        dependentField.hide();
        dependentField.find('input').val(previousValue);
        dependentField.find('input').hide();
      }
    });

    if (dependentName === inputName && dependentValue === inputValue) {
      nestedRow.show();
      nestedRow.find('input').show();
      dependentFields.show();
    } else if (dependentName === inputName && dependentValue !== inputValue) {
      nestedRow.hide();
      dependentFields.hide();
      nestedRow.find('input').hide();
    }

    if ($(inputField).parents().hasClass('onboarding__item')) {
      console.log('ima');
      console.log(inputValue);
      if (inputValue === 'true' || inputValue === 'yes') {
        const siblingButton = $(inputField).parent().siblings().children('.active');
        siblingButton.removeClass('active');
        $(inputField).addClass('active');
      } else if (inputValue === 'false' || inputValue === 'no') {
        const siblingButton = $(inputField).parent().siblings().children('.active');
        siblingButton.removeClass('active');
        $(inputField).addClass('active');
      }
    }
  }

  /**
   * Create validation for all fields inside form element
   * @param {Object} form Current form reference
   * @param {Array} inputs Array of form fields found inside form
   */
  validateFields(form, formFields, vue = false) {
    formFields.each((fieldIndex) => {
      const formField = $(formFields[fieldIndex]);
      const inputField = formField.find('input, textarea');
      const inputDataSet = vue ? inputField.data() : formField.data();
      let inputRequired = false;
      this.currentForm = form;
      if (inputField.is(':checked')) { // check preselected fields
        this.toggleDependentFields(inputField);
      }
      inputField.on('change', () => {
        console.log(1);
        this.toggleDependentFields(inputField);
      });
      if (inputDataSet && inputDataSet.dependentName
        && inputDataSet.dependentValue && inputDataSet.required) {
        const dependentInput = $(`[name="${inputDataSet.dependentName}`);
        if (dependentInput.attr('type') === 'radio') {
          inputRequired = `input[name="${inputDataSet.dependentName}"][value="${inputDataSet.dependentValue}"]:checked`;
        } else {
          inputRequired = `input[name="${inputDataSet.dependentName}"][value="${inputDataSet.dependentValue}"]`;
        }
      } else if (inputDataSet && inputDataSet.required) {
        inputRequired = parseInt(inputDataSet.required, 10) === 1;
      }
      inputField.each((index) => {
        // fieldOptions represents validation for all input fields in specific form
        const fieldOptions = {
          [$(inputField[index]).attr('name')]: {
            required: inputRequired,
            pattern: (inputDataSet && inputDataSet.pattern) ? inputDataSet.pattern : undefined,
            maxlength: (inputDataSet && inputDataSet.maxLength)
              ? inputDataSet.maxLength : undefined,
            minlength: (inputDataSet && inputDataSet.minLength)
              ? inputDataSet.minLength : undefined,
            email: (inputDataSet && inputField.attr('type') === 'email') ? true : undefined,
            compareField: (inputDataSet && inputDataSet.compareValueToField)
              ? `[name="${inputDataSet.compareValueToField}"]` : undefined,
          },
        };

        if (inputField.length > 1 && inputDataSet.requiredOne) {
          this.formRules.groups.names += `${$(inputField[index]).attr('name')} `;
          fieldOptions[$(inputField[index]).attr('name')].require_from_group = [1, $(inputField)];
        }
        // fieldErrorMessage represents message that will be displayed if validation fails
        const fieldErrorMessage = {
          [$(inputField[index]).attr('name')]: {
            required: (inputDataSet && inputDataSet.messageRequired)
              ? inputDataSet.messageRequired : undefined,
            require_from_group: (inputDataSet && inputDataSet.messageRequired)
              ? inputDataSet.messageRequired : undefined,
            pattern: (inputDataSet && inputDataSet.messagePattern)
              ? inputDataSet.messagePattern : undefined,
            maxlength: (inputDataSet && inputDataSet.messageMaxLength)
              ? inputDataSet.messageMaxLength : undefined,
            minlength: (inputDataSet && inputDataSet.messageMinLength)
              ? inputDataSet.messageMinLength : undefined,
            email: (inputDataSet && inputDataSet.messagePattern)
              ? inputDataSet.messagePattern : undefined,
            compareField: (inputDataSet && inputDataSet.compareValueToFieldValidationError)
              ? inputDataSet.compareValueToFieldValidationError : undefined,
          },

        };

        if (inputField.length > 1 && inputDataSet.requiredOne) {
          fieldErrorMessage[$(inputField[index]).attr('name')].require_from_group = inputDataSet.messageRequired;
        }
        this.formRules.rules = { ...this.formRules.rules, ...fieldOptions };
        this.formRules.messages = { ...this.formRules.messages, ...fieldErrorMessage };
      });
    });
    this.formRules.groups.names = this.formRules.groups.names.replace(/ +$/, '');
  }

  /**
   * Register delete user form with consent modal
   */
  registerDeleteUserForm() {
    if (this.deleteUserForm) {
      const agreeCheckbox = this.deleteUserForm.find('#checkbox-id');
      const submitButton = this.deleteUserForm.find('button[type="submit"]');
      if (agreeCheckbox) {
        agreeCheckbox.on('change', (event) => {
          const buttonDisabled = $(event.target).prop('checked');
          submitButton.prop('disabled', !buttonDisabled);
        });
      }
      this.formRules = {
        errorElement: 'div',
        groups: {
          names: '',
        },
        rules: {},
        messages: {},
        async submitHandler(formElement, event) {
          event.preventDefault();
          const formInstance = $(formElement);
          const formUrl = formInstance.attr('action');
          const formArray = formInstance.serializeArray();
          this.formData = {};

          for (let i = 0; i < formArray.length; i += 1) {
            this.formData[formArray[i].name] = formArray[i].value;
          }
          if (formUrl) {
            try {
              await clubApi.post(formUrl, this.formData);
              await siteApi.get('/account/signout');
              Cookies.remove('bdp.session');

              window.location.reload();
            } catch {
              // Delete not done
            }
          }
        },
      };
      this.registerFieldMultiple(this.deleteUserForm);
    }
  }
}
